<template>
<div>
  <a-list item-layout="horizontal" :data-source="msgs">
    <a-list-item slot="renderItem" slot-scope="item, index">
      <a slot="actions" @click="read(item)">已读</a>
      <a-list-item-meta
        :description="item.content"
      >
 
        <a slot="title" :href="item.url" v-if="item.url">{{ item.title }}</a>
        <a slot="title" @click="detail(item)" v-else>{{ item.title }}</a>
        
        <a-avatar
          slot="avatar"
          style="backgroundColor:#87d068" icon="user" />
      </a-list-item-meta>
      <div class="time">{{item.createTime}}</div>
    </a-list-item>
    
  </a-list>

  <a-modal
      :title="currentMsg.title"
      :visible="detailVisible"
      okText="确认"
      cancelText="关闭"
      @ok="read(currentMsg)"
       @cancel="read(currentMsg)"
      @afterClose="read(currentMsg)"
    >
      <p>{{ currentMsg.content }}</p>
    </a-modal>
</div>
</template>
<script>
export default {
  data() {
    return {
      msgs:[],
      currentMsg:{},
      detailVisible:false
    };
  },
  methods:{
    getMsgs(){
      let url = "/api/message/website/select-by-receiver/"+this.currentUser.id;
      this.$req.get(url,{},(res)=>{
        this.msgs = res.data;
      })
    },
    detail(msg){
     this.currentMsg = msg;
     this.detailVisible = true;
    },
     read(msg){
      this.$req.formDataPost("/api/message/read/",{
        msgId:msg.id,
        receiverId:this.currentUser.id
      },(res)=>{
        this.detailVisible = false;
        this.getMsgs();
      })
    }
  },
  created:function(){
    this.getMsgs();
  },
  computed: {
    currentUser: function () {
      return this.$store.state.user;
    },
  },
};
</script>
<style>
@media screen and (max-width: 600px) {
  .time{
    display: none;
  }
}
</style>
